export const APP_ICONS = {
  reports: 'fa-solid fa-table',
  studio: 'fa-solid fa-chart-simple',
  discovery: 'fa-solid fa-magnifying-glass',
  dm: 'fa-solid fa-database',
  integrations: 'fa-solid fa-circle-nodes',
  advertisers: 'fa-solid fa-presentation-screen',
  leads: 'fa-solid fa-magnifying-glass-dollar',
  advisor: 'fa-solid fa-bell',
  forecasting: 'fa-solid fa-chart-line',
  snapshot: 'fa-solid fa-camera',
  cfr: 'fa-solid fa-presentation-screen',
  optimize: 'fa-solid fa-bullseye-arrow',
};

export const APP_CONFIGS = [
  {
    appKey: 'studio',
    label: 'Studio',
    icon: APP_ICONS.studio,
    colors: {
      text: 'tw-text-sky-600',
      border: 'tw-border-sky-200',
      icon: 'tw-text-sky-400',
      background: 'tw-bg-sky-100',
      hover: {
        border: 'hover:tw-border-sky-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    items: [
      { label: 'All Dashboards', url: '/all-dashboards' },
      { label: 'My Dashboards', url: '/my-dashboards' },
      { label: 'Scheduled Dashboards', url: '/scheduled-dashboards' },
      { label: 'Shared Dashboards', url: '/shared-dashboards' },
      { label: 'Shared With Me', url: '/shared-with-me' },
      { label: 'Dashboard Templates', url: '/dashboard-templates' },
    ],
  },
  {
    appKey: 'reports',
    label: 'Reports',
    icon: APP_ICONS.reports,
    colors: {
      text: 'tw-text-lime-600',
      border: 'tw-border-lime-200',
      icon: 'tw-text-lime-400',
      background: 'tw-bg-lime-100',
      hover: {
        border: 'hover:tw-border-lime-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    items: [
      { label: 'All Reports', url: '/reports-list' },
      { label: 'My Reports', url: '/my-reports-list' },
      { label: 'Scheduled Reports', url: '/scheduled-reports-list' },
      { label: 'Shared Reports', url: '/shared-reports' },
      { label: 'Shared With Me', url: '/shared-with-me' },
      { label: 'Report Templates', url: '/templates-list' },
    ],
  },
  {
    appKey: 'discovery',
    label: 'Discovery',
    icon: APP_ICONS.discovery,
    colors: {
      text: 'tw-text-emerald-600',
      border: 'tw-border-emerald-200',
      icon: 'tw-text-emerald-400',
      background: 'tw-bg-emerald-100',
      hover: {
        border: 'hover:tw-border-emerald-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    items: [
      { label: 'All Discoveries', url: '/discoveries-route' },
      { label: 'My Discoveries', url: '/my-discoveries' },
      { label: 'Shared Discoveries', url: '/shared-discoveries' },
      { label: 'Shared with me', url: '/shared-with-me' },
    ],
  },
  {
    appKey: 'advertisers',
    label: 'Advertisers',
    icon: APP_ICONS.advertisers,
    colors: {
      text: 'tw-text-blue-600',
      border: 'tw-border-blue-200',
      icon: 'tw-text-blue-400',
      background: 'tw-bg-blue-100',
      hover: {
        border: 'hover:tw-border-blue-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/advertisers',
  },
  {
    appKey: 'leads',
    label: 'Leads',
    icon: APP_ICONS.leads,
    colors: {
      text: 'tw-text-cyan-600',
      border: 'tw-border-cyan-200',
      icon: 'tw-text-cyan-400',
      background: 'tw-bg-cyan-100',
      hover: {
        border: 'hover:tw-border-cyan-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/leads',
    website: 'https://www.burtintelligence.com/burt-leads',
  },
  {
    appKey: 'advisor',
    label: 'Advisor',
    icon: APP_ICONS.advisor,
    colors: {
      text: 'tw-text-purple-600',
      border: 'tw-border-purple-200',
      icon: 'tw-text-purple-400',
      background: 'tw-bg-purple-100',
      hover: {
        border: 'hover:tw-border-purple-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/advisor',
    website: 'https://www.burtintelligence.com/burt-advisor',
  },
  {
    appKey: 'optimize',
    label: 'Optimize',
    icon: APP_ICONS.optimize,
    colors: {
      text: 'tw-text-teal-600',
      border: 'tw-border-teal-200',
      icon: 'tw-text-teal-400',
      background: 'tw-bg-teal-100',
      hover: {
        border: 'hover:tw-border-teal-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/optimize',
  },
  {
    appKey: 'forecasting',
    label: 'Forecasting',
    icon: APP_ICONS.forecasting,
    colors: {
      text: 'tw-text-orange-600',
      border: 'tw-border-orange-200',
      icon: 'tw-text-orange-400',
      background: 'tw-bg-orange-100',
      hover: {
        border: 'hover:tw-border-orange-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/forecasting',
    website: 'https://www.burtintelligence.com/forecasting',
  },
  {
    appKey: 'cfr',
    label: 'Slides',
    icon: APP_ICONS.cfr,
    colors: {
      text: 'tw-text-pink-600',
      border: 'tw-border-pink-200',
      icon: 'tw-text-pink-400',
      background: 'tw-bg-pink-100',
      hover: {
        border: 'hover:tw-border-pink-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/cfr',
  },
  {
    appKey: 'snapshot',
    label: 'Snapshot',
    icon: APP_ICONS.snapshot,
    colors: {
      text: 'tw-text-indigo-600',
      border: 'tw-border-indigo-200',
      icon: 'tw-text-indigo-400',
      background: 'tw-bg-indigo-100',
      hover: {
        border: 'hover:tw-border-indigo-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/snapshot',
  },
  {
    appKey: 'dm',
    label: 'Data Management',
    icon: APP_ICONS.dm,
    colors: {
      text: 'tw-text-red-600',
      border: 'tw-border-red-200',
      icon: 'tw-text-red-400',
      background: 'tw-bg-red-100',
      hover: {
        border: 'hover:tw-border-red-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/dm',
  },
  {
    appKey: 'integrations',
    label: 'Integrations',
    icon: APP_ICONS.integrations,
    colors: {
      text: 'tw-text-amber-600',
      border: 'tw-border-amber-200',
      icon: 'tw-text-amber-400',
      background: 'tw-bg-amber-100',
      hover: {
        border: 'hover:tw-border-amber-300 hover:tw-shadow-md hover:tw-shadow-gray-200',
      },
    },
    url: '/integrations',
  },
];
